import cn from 'classnames';
import React, { Fragment } from 'react';
interface PortalEntryProps {
    label: string;
    value: number | string | React.ReactNode;
    className?: string;
    labelClassName?: string;
    valueOnly?: boolean;
    disabled?: boolean;
    required?: boolean;
    hidden?: boolean;
}

const PortalEntry = (props: PortalEntryProps) => {
    const {
        label,
        value,
        className = '',
        labelClassName = '',
        valueOnly = false,
        disabled = false,
        required = false,
        hidden = false
    } = props;

    return (
        <Fragment>
            {!hidden && (
                <div className={cn('flex flex-col gap-1 justify-between text-brand-text w-full')}>
                    <label className="flex justify-between relative text-xs text-brand-neutral-300 w-full">
                        <div
                            className={cn('', {
                                'pl-3': required
                            })}>
                            {required && (
                                <sup className="absolute -top-1 left-0 text-lg mr-1.5 text-secondaryLight">*</sup>
                            )}
                            {label}
                        </div>
                    </label>

                    <span
                        className={cn(
                            'block w-full break-all rounded-md shadow-sm text-sm',
                            {
                                'text-brand-neutral-400 cursor-not-allowed': disabled,
                                'px-3 py-2 bg-brand-background-dark border border-brand-neutral-700': !valueOnly
                            },
                            className
                        )}>
                        {value || '-'}
                    </span>
                </div>
            )}
        </Fragment>
    );
};

export default PortalEntry;
